import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable } from '@y42/angular/util';
import { Icon } from '@y42/core/icon';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuickFilterModel } from '../model/quick-filter.model';

@UntilDestroy()
@Component({
  selector: 'y42-list-view-quick-filter',
  templateUrl: './list-view-quick-filter.component.html',
  styleUrls: ['./list-view-quick-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListViewQuickFilterComponent {
  @Input() @InputObservable() filter!: QuickFilterModel;
  private readonly filter$!: Observable<undefined | QuickFilterModel>;
  @Input() isDefaultFilter = false;
  @Input() index = 0;

  @Output() setFilter = new EventEmitter<void>();
  @Output() editFilter = new EventEmitter<void>();
  @Output() deleteFilter = new EventEmitter<void>();

  readonly state = connectState(this, {
    icon: this.filter$.pipe(
      map((filter): undefined | Icon => {
        if (!filter) {
          return;
        }

        return filter.icon;
      }),
    ),
  });
}
